import "./index.css";
import React from "react";
import Item from "./Item";
import { request } from "../../../request";
import { Avatar, Button, Modal, Popover, Tooltip } from "antd";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";

import { ICON } from "../GuidelineSelect/GuidelineCheckbox";

import type { TypeItemProps } from "./Item";

type User = Omit<TypeItemProps, "onClick">;

interface TypeContactProps<T extends User = User>
  extends Pick<T, "lender_id" | "lender_name"> {
  /**
   * @param list 联系人列表
   */
  list?: T[];
  /**
   * @name onEdit 编辑新增事件
   * @description 如果没有传递这个方法，则不显示新增、编辑功能入口
   */
  onEdit?(data: Partial<User>): void;
}

/**
 * @name Contact 联系方式
 */
const Contact: React.FC<TypeContactProps> = ({
  onEdit,
  lender_id,
  lender_name,
  list = [],
}) => {
  function onStopEvent(e: React.MouseEvent<HTMLSpanElement>) {
    e.stopPropagation();
  }

  function onEditItem(user?: Partial<User>) {
    onEdit({ lender_id, lender_name, ...(user || {}) });
  }

  const onClick: TypeItemProps["onClick"] = async (type, user) => {
    switch (type) {
      case "DELETE":
        const confirm = Modal.confirm({
          title: (
            <>
              <span>Confirm delete</span>
              <CloseOutlined
                onClick={() => confirm.destroy()}
                rev={undefined}
              />
            </>
          ),
          className: "modal-delete",
          content:
            "Do you really want to delete this contact? This process cannot be undone.",
          okText: "Delete",
          async onOk() {
            await request(
              `/api/v1/mortgagegpt/deleteLenderContacts/${user.id}`,
              { method: "DELETE" },
            );
            onEdit({});
          },
          onCancel() {
            onEdit({});
          },
        });
        return;
      case "UPDATE":
        return onEditItem(user);
      default:
        return;
    }
  };

  const LENGTH = list?.length;

  return (
    <div onClick={onStopEvent}>
      <Popover
        title={
          LENGTH ? (
            <>
              <span>
                {ICON[lender_name] ? <img src={ICON[lender_name]} /> : null}
                {lender_name}
              </span>
              {onEdit ? (
                <Button onClick={() => onEditItem()} size="small" type="link">
                  Add
                </Button>
              ) : null}
            </>
          ) : null
        }
        placement="left"
        content={
          LENGTH ? (
            <div
              className={LENGTH > 3 ? "scenario-contact-person-overflow" : ""}
            >
              {list.map((v) => (
                <Item
                  {...v}
                  key={v.id}
                  lender_name={lender_name}
                  onClick={onEdit && !v.is_default ? onClick : undefined}
                />
              ))}
            </div>
          ) : null
        }
        rootClassName="scenario-contact-person"
      >
        <span onClick={onStopEvent}>
          {LENGTH ? (
            <Avatar.Group className="scenario-contact">
              {list.slice(0, 2).map((v) => (
                <Avatar key={v.id}>
                  {v.first_name?.[0]}
                  {v.last_name?.[0]}
                </Avatar>
              ))}
              {LENGTH > 2 ? (
                <Avatar>
                  <span className="scenario-contact-max">+{LENGTH - 2}</span>
                </Avatar>
              ) : null}
            </Avatar.Group>
          ) : onEdit ? (
            <Tooltip title="Add contact">
              <PlusOutlined
                rev={undefined}
                className="scenario-contact-insert"
                onClick={() => onEditItem({ lender_id })}
              />
            </Tooltip>
          ) : null}
        </span>
      </Popover>
    </div>
  );
};

export default Contact;
